module.exports = __webpack_public_path__ + "img/62b9e096-e6bb-4a63-8c04-bb7da5012b1d.0ea9f21a.png";